import { Component } from '@angular/core';

@Component({
    selector: 'em-auth-wrapper',
    templateUrl: './auth-wrapper.component.html',
    styleUrls: ['./auth-wrapper.component.scss'],
    standalone: false
})
export class AuthComponent {

}
